export default __webpack_public_path__ + "static/media/logo.83c25764.png";